"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleMethods = void 0;
const email_1 = require("./email");
const phone_1 = require("./phone");
const pattern_1 = require("./pattern");
const required_1 = require("./required");
const range_1 = require("./range");
const document_1 = require("./document");
const custom_1 = require("./custom");
const handleMethods = ({ value, name, options, context }) => {
    let isValid = true;
    const methods = {
        handleRequiredField: options.required && (() => (0, required_1.handleRequiredField)({ value, name, options, context })),
        handleMinLengthField: options.min && (() => (0, range_1.handleMinLengthField)({ value, name, options, context })),
        handleMaxLengthField: options.max && (() => (0, range_1.handleMaxLengthField)({ value, name, options, context })),
        handleEmailField: options.email && (() => (0, email_1.handleEmailField)({ value, name, options, context })),
        handlePatternField: options.pattern && (() => (0, pattern_1.handlePatternField)({ value, name, options, context })),
        handlePhoneField: options.phone && (() => (0, phone_1.handlePhoneField)({ value, name, options, context })),
        handleDocumentField: options.document && (() => (0, document_1.handleDocumentField)({ value, name, options, context })),
        handleCustomValidationField: options.custom && (() => (0, custom_1.handleCustomValidationField)({ value, name, options, context })),
    };
    if (!value && options.optional) {
        context.actions?.clearError(name);
        return isValid;
    }
    Object.entries(methods).forEach(([key, method]) => {
        if (method && isValid) {
            isValid = method();
        }
    });
    return isValid;
};
exports.handleMethods = handleMethods;
